<template>
  <v-text-field
    v-model="url"
    class="checkColor"
    readonly
    outlined
    hide-details
    :append-outer-icon="!isActive ? 'mdi-content-copy' : 'mdi-check'"
    @click:append-outer="copyToClipboard();"
  />
</template>
<script>
export default {
  name: "SurveyIconTextField",
  props: {
    url: { type: String, default: "" },
  },
  data() {
    return {
      isActive: false
    }
  },
  methods: {
    copyToClipboard() {
      this.isActive = !this.isActive;
      if (!navigator.clipboard) {
        this.legacyCopy(this.url);
      } else {
        navigator.clipboard.writeText(this.url)
      }
      setTimeout(() => {
        this.isActive = !this.isActive;
      }, 2000)
    },
    legacyCopy(text) {
      let textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
  }
}
</script>
<style>
.checkColor .mdi-check{
  color: rgb(27, 167, 27) !important;
}
</style>